<div class="table">
  <div class="row header {{ color }}" [class.company]="showCompany">
    <div>{{ 'estate.name' | locCap }}</div>
    <div *ngIf="showCompany">{{ 'label.firm' | locCap }}</div>
    <div>{{ 'emp.accessDate' | loc }}</div>
    <div>
      <ng-container *ngIf="canDelete && onDelete.observers.length">{{ 'label.actions' | locCap }}</ng-container>
    </div>
  </div>
  <app-expandable-list [allData]="adminVMs" [sliceLength]="sliceLength">
    <ng-template let-admin="data">
      <div class="row" [class.company]="showCompany">
        <div>{{ admin.estateName }}</div>
        <div *ngIf="showCompany">{{ admin.companyName ?? '' }}</div>
        <div>{{ admin.createDate | lDate: 'dtShort' }}</div>
        <div>
          <a *ngIf="canDelete && onDelete.observers.length" (click)="onDelete.emit(admin)">
            <mat-icon color="primary">delete</mat-icon>
          </a>
        </div>
      </div>
    </ng-template>
  </app-expandable-list>
</div>
